import React from "react";
import PropTypes from 'prop-types';
import ReactTooltip from "react-tooltip";
import styles from './input.module.css';

export const Input = ({ value = '', label }) => {
    const normalizedValue = value ?? '';
    const displayValue = typeof normalizedValue === 'number' ? String(normalizedValue) : normalizedValue;
    const tooltipId = `${label}-${displayValue}`;
    let node = <></>;
    if (displayValue !== '') {
        node = <ReactTooltip id={tooltipId} place="top" effect="solid">{displayValue}</ReactTooltip>;
    }
    return (
        <div className={styles.wrapper}>
            <label className={styles.input_label}>{label}</label>
            <input data-tip data-for={tooltipId}  className={styles.input} value={displayValue} readOnly />
            {node} 
        </div>
    );
}

Input.propTypes = {
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

export default Input;